import { Image } from '@components/gassan-ui'
import { Spinner, Text } from '@components/old-rolex-ui'
import { useTranslation } from 'next-i18next'

type Product360ViewPlaceholderProps = {
  title: string
  placeholderImage: string
}

const Product360ViewPlaceholder: React.FC<Product360ViewPlaceholderProps> = ({
  title,
  placeholderImage,
}) => {
  const { t } = useTranslation('rolex')

  return (
    <div className="absolute flex h-full w-full items-center justify-center bg-black">
      <Image
        alt={`${title} - turntable placeholder`}
        sources={[placeholderImage]}
        loading="eager"
        className="absolute h-full w-full opacity-50"
      />
      <div className="pointer-events-none relative z-10 flex flex-col items-center justify-center text-white">
        <Spinner />
        <Text variant="sectionTitle" className="rounded-lg p-2 !text-inherit">
          {t('detail.loading360View')}
        </Text>
      </div>
    </div>
  )
}

export default Product360ViewPlaceholder
